import { Injectable } from '@angular/core';
import { QuerifyService } from '@core/services/querify.service';
import { Group, PagedResult } from '@interfaces';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Mutations } from './mutations';
import { Queries } from './queries';

@Injectable({
  providedIn: 'root'
})
export class GroupsApi {
  constructor(
    private apollo: Apollo,
    private mutations: Mutations,
    private queries: Queries,
    private querify: QuerifyService
  ) { }

  save(group): Observable<any> {
    return this.apollo.mutate({
      mutation: this.mutations.createGroup(),
      variables: {
        input: group
      }
    });
  }

  update(id, group): Observable<any> {
    return this.apollo.mutate({
      mutation: this.mutations.updateGroup(),
      variables: {
        id: id,
        input: group
      }
    });
  }

  search(query?, options?): Observable<PagedResult> {
    options = this.querify.transformOptions(query, options);
    return this.apollo
      .query({
        query: this.queries.getGroups(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['groups'];
        })
      );
  }

  searchOne(id: String): Observable<Group> {
    return this.apollo
      .query({
        query: this.queries.getGroup(),
        variables: { id: id }
      })
      .pipe(
        map(({ data }) => {
          return data['group'];
        })
      );
  }
}
